import { Link } from 'react-router-dom';

const Card = ({ tour, whatsapp }) => {
    const waLink = whatsapp
        ? `${whatsapp}?text=${encodeURIComponent(`Hi! I'm interested in booking this tour: ${tour.title}`)}`
        : null;
    return (
        <div className="tour-card w-full sm:w-[calc(33.333%-16px)]">
            {/* Image */}
            <div className="relative overflow-hidden h-56">
                <img
                    src={tour.banner?.replace(/^http:/, 'https:')}
                    className="w-full h-full object-cover transition-transform duration-700 hover:scale-110"
                    alt={tour.title}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />

                {/* Duration badge */}
                {tour.duration && (
                    <div className="absolute top-4 right-4 bg-black/60 backdrop-blur-sm border border-white/15 rounded-full px-3 py-1">
                        <span className="font-manrope text-white/80 text-xs">{tour.duration}</span>
                    </div>
                )}

                {/* Slide-up overlay on hover */}
                <div className="tour-card-overlay">
                    <Link
                        to={`/country/tour/${tour.id}`}
                        className="btn-gold w-full text-center block"
                    >
                        Discover the tour
                    </Link>
                </div>
            </div>

            {/* Info */}
            <div className="p-6 flex flex-col gap-3">
                <h5 className="font-unbounded font-bold text-base text-white leading-snug">
                    {tour.title}
                </h5>
                <p className="font-manrope text-white/55 text-sm leading-relaxed line-clamp-3">
                    {tour.description}
                </p>
                {tour.price && (
                    <div className="flex items-center gap-2 mt-1">
                        <span className="font-unbounded text-it-green text-sm font-bold">
                            {tour.price.split(',')[0].trim()}
                        </span>
                    </div>
                )}

                {waLink && (
                    <a
                        href={waLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={e => e.stopPropagation()}
                        className="mt-2 flex items-center gap-2 w-full justify-center py-3 rounded-2xl border border-white/10 bg-white/5 hover:bg-[#25D366]/15 hover:border-[#25D366]/40 transition-all duration-200 group/wa"
                    >
                        <svg width="16" height="16" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-white/50 group-hover/wa:text-[#25D366] transition-colors duration-200">
                            <path fillRule="evenodd" clipRule="evenodd" d="M18.957 15.6555C18.6327 15.4933 17.0423 14.7118 16.7462 14.6029C16.4501 14.4951 16.2346 14.4418 16.018 14.7662C15.8024 15.0884 15.183 15.8177 14.9947 16.0333C14.8053 16.2499 14.617 16.276 14.2937 16.1149C13.9704 15.9516 12.9276 15.6109 11.6921 14.5093C10.7309 13.6515 10.081 12.5924 9.89271 12.268C9.70439 11.9447 9.87203 11.7694 10.0342 11.6083C10.1801 11.4635 10.3575 11.2306 10.5197 11.0423C10.6819 10.8529 10.7352 10.7179 10.843 10.5013C10.9519 10.2857 10.8974 10.0974 10.8158 9.93521C10.7352 9.77302 10.0887 8.18047 9.81869 7.53279C9.55635 6.90252 9.28966 6.98851 9.09154 6.97763C8.90213 6.96892 8.6866 6.96674 8.47107 6.96674C8.25554 6.96674 7.90503 7.0473 7.60894 7.37168C7.31177 7.69498 6.47685 8.47765 6.47685 10.0702C6.47685 11.6616 7.63507 13.1998 7.79726 13.4164C7.95945 13.6319 10.0778 16.8997 13.3227 18.3007C14.0956 18.6338 14.6976 18.833 15.1667 18.981C15.9418 19.2281 16.6471 19.1933 17.2045 19.1095C17.825 19.017 19.1181 18.3268 19.3881 17.5714C19.657 16.8159 19.657 16.1682 19.5764 16.0333C19.4959 15.8983 19.2803 15.8177 18.9559 15.6555H18.957ZM13.0549 23.714H13.0506C11.1232 23.7144 9.23128 23.1963 7.57302 22.214L7.18114 21.9811L3.1078 23.05L4.19526 19.079L3.93945 18.6719C2.86194 16.9567 2.29171 14.9717 2.29466 12.9461C2.29683 7.01355 7.12345 2.18694 13.0593 2.18694C15.9331 2.18694 18.6348 3.30814 20.6661 5.34154C21.6679 6.33928 22.462 7.52578 23.0024 8.8324C23.5427 10.139 23.8186 11.5398 23.8141 12.9538C23.812 18.8863 18.9853 23.714 13.0549 23.714ZM22.2118 3.7969C21.0124 2.58961 19.5854 1.63236 18.0134 0.980608C16.4413 0.328855 14.7556 -0.00443719 13.0539 4.4606e-05C5.91952 4.4606e-05 0.111032 5.80744 0.108855 12.945C0.105549 15.2166 0.701432 17.4488 1.83638 19.4165L0 26.1252L6.8622 24.3247C8.76049 25.359 10.8877 25.9009 13.0495 25.9009H13.0549C20.1893 25.9009 25.9978 20.0935 25.9999 12.9548C26.0052 11.2537 25.6731 9.56848 25.0229 7.99655C24.3727 6.42461 23.4172 4.9972 22.2118 3.7969Z" fill="currentColor"/>
                        </svg>
                        <span className="font-unbounded text-white/50 group-hover/wa:text-[#25D366] text-[10px] uppercase tracking-wider transition-colors duration-200">
                            Book this programme
                        </span>
                    </a>
                )}
            </div>
        </div>
    );
};

export default Card;
